module.exports = __webpack_public_path__ + "images/168_320.jpg";